var map = {
	"./ITHelp.png": 52,
	"./animalShelter.png": 53,
	"./babySit.png": 54,
	"./birdHouse.png": 55,
	"./childSupport.png": 56,
	"./cleanWater.png": 57,
	"./clearnPark.png": 58,
	"./clothSwap.png": 59,
	"./driveSafety.png": 60,
	"./extraVolunteer.png": 61,
	"./foodCharity.png": 62,
	"./goodEducation.png": 63,
	"./libraryBooks.png": 64,
	"./musicLessons.png": 65,
	"./newBooks.png": 66,
	"./refuseShelter.png": 67,
	"./riverClean.png": 68,
	"./schoolSuffiles.png": 69,
	"./studyGroup.png": 70,
	"./stuffedAnimals.png": 71,
	"./voteRegister.png": 72
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29;